<template>
  <b-card class="custom-card white-bg">
    <div class="full-width-100" id="top-sites-countries">
      <b-card-header>
        <div class="card-text-strong">
          <span>Top 5 Locations for Participant Enrollment</span>
          <span class="float-right enrol-tabs">
            <b-tabs v-model="tabIndex">
              <b-tab :title="`Sites`"> </b-tab>
              <b-tab :title="`Countries`"> </b-tab>
            </b-tabs>
          </span>
        </div>
      </b-card-header>
      <b-card-body class="pl-30">
        <table class="table table-hover table-borderless mt-10" v-if="tabIndex == 1">
          <tbody>
            <div v-if="topFiveCountries.length > 0">
              <tr v-for="(item, index) in topFiveCountries" :key="index">
                <td style="width: 5px" class="top-time-activity-text">
                  <span class="pdt-5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 21 20">
                      <g clip-path="url(#clip0)">
                        <path
                          :fill="primaryColor"
                          d="M10.258 19.951c5.514 0 10-4.485 10-10 0-5.513-4.486-9.999-10-9.999s-10 4.486-10 10 4.486 10 10 10zm0-.412c-1.121 0-2.197-.195-3.198-.55-.023-.228.013-.522.002-.682-.012-.169-.034-.55.172-.653.206-.104.138-.069.584-.447.447-.378.508-.245.447-.378-.109-.237.618-.722.722-.756.103-.034.171-.344.446-.756.275-.412.275-.516.378-.618.103-.104-.137-.207 0-.516.138-.309 0-.55-.171-.825-.172-.275-.31-.825-.413-.893-.103-.069-.59-.225-.763-.344-.123-.084-.165-.171-.508-.309-.344-.137-.392-.226-.482-.343-.07-.093-.175-.207-.414-.207s-.6-.113-.802-.137c-.108-.013-.325 0-.433 0-.172 0-.533.075-.687 0-.154-.076-.344-.447-.412-.55-.07-.103-.525-.61-.722-.79-.08-.075-.297-.176-.344-.275-.018-.039-.017-.132 0-.172.033-.078.162-.208.24-.24.057-.024.138 0 .241 0h.55c.103 0 .481-.103.584-.172.103-.069.103-.447.206-.55.103-.103.206-.275.31-.31.103-.034-.207.207.103-.034.31-.24.88-.653.87-.721-.011-.07-.608-.241 0-.31.607-.068 1.129-.148 1.467-.31.093-.044.24-.171.309-.274.068-.103.172-.378.103-.515-.068-.138-.103-.379-.447-.653-.343-.275-.447-.456-.584-.62-.062-.073-.185-.237-.275-.274-.132-.054-.435-.038-.573 0-.073.02-.114.069-.251.172-.138.103.068 0-.138.103-.206.103-.24.103-.344.138-.103.034-.393.113-.515.068-.08-.029-.19-.172-.24-.24-.069-.092-.207-.378-.104-.447.104-.068.201-.27.275-.353.073-.08.26-.197.344-.265.07-.058.203-.184.275-.24.047-.037.133-.131.192-.138.273-.033.391.103.506.171.072.043.156.204.23.241.085.043.274.034.377.034.103 0 0 .035.241-.137.24-.172.344.034.24-.172-.103-.206-.377-.515-.446-.618-.069-.104-.266-.405-.413-.447-.099-.029-.309.069-.412 0-.103-.069-.132-.034-.324 0-.191.034.29 0-.191.034-.482.035-.366 0-.482.035-.094.028-.104.068-.378.103-.275.035-.068.035-.584.035h-.3C5.504 1.497 6.91.834 8.445.539c-.084.105-.268.26-.352.348-.047.048-.144.145-.172.206-.022.048-.068.167-.035.206.113.133.447 0 .585.378.137.378.217.316.137.378-.14.11-.11.522-.171.688-.027.072-.118.2-.138.275-.053.197-.034.561.24.779.275.217.302.134.275.217-.058.182.472.325.619.447.103.085.18.172.434-.31.253-.48.46-.652.562-.72.103-.07.365-.28.482-.379.083-.07.24-.206.31-.309.067-.103.495-.41.617-.584.096-.137.256-.454.24-.619-.008-.094-.17-.275 0-.378.173-.103.369-.329.414-.481.003-.013.004-.03.003-.05 1.44.346 2.754 1.015 3.859 1.928-.12.139-.326.276-.426.355-.242.192-.877.376-1.066.62-.076.098-.069.375-.137.48-.073.113-.355.222-.412.344-.011.023 0 .053 0 .1v.074c0 .047-.017.081 0 .1.08.093.36.06.48.069.138.01.414.014.55 0 .044-.004.137-.009.172-.034.056-.041.098-.184.138-.24.069-.101.206-.314.309-.379.06-.038.205-.08.275-.068.08.012.266.09.275.171.004.035-.035.035 0 .138.034.103.034.378-.069.481-.103.103-.447.275-.55.344-.103.068-.202.099-.275.103-.095.005-.282-.03-.378-.035-.103-.005-.312-.024-.412 0-.056.014-.17.058-.207.103-.043.055-.034.138-.137.24-.103.104-.067.101-.103.104-.052.005-.16.058-.206.034-.069-.035-.12-.2-.138-.275-.018-.075.04-.243 0-.309-.05-.081-.25-.15-.343-.171-.128-.03-.516 0-.516.103s.103.24 0 .309c-.103.068-.505.134-.584.275-.042.074.034.24.138.31.103.068.24.103.343.137.103.034.24-.001.31.034.066.034.148.17.171.24.01.033.004.104 0 .138-.013.106.003.425-.103.413-.051-.006 0-.103-.206 0-.207.103-.343 0-.378.103-.035.103-.435.577-.275.653.055.025.035-.069.172.171.137.24.173.182.137.24-.041.068.069.138.069.31s.378-.171 0 .172c-.378.344-.368.384-.515.481-.092.06-.173.069-.344.275-.172.206-.362.438-.378.618-.014.152.132.438.172.585.035.129.103.412.138.515.034.104.14.317.206.413.144.211.421.68.652.79.133.062.439-.007.585 0 .095.005.284.052.378.034.085-.015.206-.103.344.035.137.137.137.24.24.275.103.034.475.28.412.412-.022.047-.034 0 0 .207.035.206.037.748.07.996.025.2.139.59.17.789.054.332.012 1.028.138 1.34.058.142.24.414.378.481.139.068.47.041.618 0 .077-.021.173-.103.241-.206.069-.103.53-.817.687-1.1.14-.251.364-.785.516-1.03.036-.06.103-.138.137-.241.034-.103.24-.963.275-1.066.035-.102.072-.612.206-.755.046-.05.103-.035.207-.172.103-.138.239-.267.274-.378.032-.098.07-.337 0-.413-.076-.082-.358.035-.446-.034-.083-.065-.035-.103-.24-.344-.207-.24-.135-.206-.207-.24-.149-.072-.353-.362-.413-.515-.046-.12-.035-.549 0-.515.035.033.21-.23.275-.31.031-.037.09-.145.138-.138.126.018.198.328.24.448.015.04.047.129.035.17-.026.086-.137.138.103.344.24.206.515.24.515.344 0 .103.107.188.172.206.058.016.187.027.24 0 .056-.028.104-.138.207-.138s-.069.035.103 0c.065-.013.198-.064.319-.079-.334 4.985-4.493 8.94-9.562 8.94zm7.113-11.763c-.112.151-.137.12-.171.128-.082.02 0 .252 0 .336v.171c0 .069.049.227 0 .275-.061.06-.259 0-.344 0h-1.134c-.103 0-.34.073-.413 0-.024-.024.024-.113 0-.137-.024-.024-.105.011-.137 0-.052-.019-.13-.101-.172-.138-.073-.065-.185-.238-.275-.275-.084-.035-.279.03-.365 0-.161-.057-.253-.206-.356-.584-.103-.378.477-.643.721-.687.085-.016.26-.015.344 0 .099.017.28.113.378.137.124.03.423-.027.507.069.017.02.006.078 0 .103-.02.075-.095.171-.198.24-.103.07.49.008.653 0 .088-.004 0 0 .31-.171.308-.172.068-.172.068-.275 0-.103.034-.275.034-.378 0-.103.576.185.756.275l.275.137c.138.069.063.285 0 .343-.047.046-.253.04-.24.104.02.1 0 0-.24.327zM1.424 6.226c.06.236.02.634.037.81.022.239-.02.722 0 .962.022.252.041.78.172.996.073.12.347.244.447.344.06.06.148.211.206.275.18.198.585.55.79.722.141.117.431.343.584.446.182.123.587.306.756.447.07.058.18.207.24.275.094.105.31.343.344.446.035.103-.035.172 0 .275.035.103.226 0 .01.275s-.32.31-.32.516c0 .205-.088.422-.034.55.04.09.25.162.31.24.056.074.096.265.146.343.123.194.443.53.61.688.04.037.148.087.172.137.037.078 0 .258 0 .344 0 .163-.072.506 0 .653.056.116.31.24.31.412s.377 1.718.412 1.925c.021.129.055.35.052.532C3.155 17.415.67 13.97.67 9.952c0-1.321.268-2.58.753-3.726z"
                        />
                        <circle cx="10.306" cy="9.75" r="9.5" :stroke="primaryColor" />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <path fill="#fff" d="M0 0H20V20H0z" transform="translate(.306)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </td>
                <td style="width: 5px" class="top-time-activity-text-padding-right">
                  <span class="top-time-activity-text-number">{{ index + 1 }}</span>
                </td>
                <td style="text-align: left" class="top-time-activity-text">
                  {{ item.countryName }}
                </td>
                <td style="text-align: right" class="top-time-activity-text">
                  <span>{{ item.numParticipant }}</span>
                </td>
              </tr>
            </div>

            <div v-else class="align-center p-60">
              <div class="card-text-title no-data" v-if="dataLoaded">
                No Data In
              </div>
            </div>
          </tbody>
        </table>
        <table class="table table-hover table-borderless mt-10" v-if="tabIndex == 0">
          <tbody>
            <div v-if="topFiveSites.length > 0">
              <tr v-for="(item, index) in topFiveSites" :key="index">
                <td style="width: 5px" class="top-time-activity-text">
                  <span class="pdt-5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 19" :fill="primaryColor">
                      <g clip-path="url(#clip0)">
                        <path
                          fill-rule="evenodd"
                          d="M11.25 8.708H4.585c-.332 0-.65-.125-.884-.347-.234-.223-.366-.525-.366-.84V5.54H1.667v11.876h4.167v-4.355H10v4.355h4.166V5.542H12.5V7.52c0 .315-.132.617-.367.84-.234.222-.552.347-.883.347zm1.25-4.75v-2.77c0-.315-.131-.617-.366-.84C11.9.125 11.582 0 11.251 0H4.584c-.332 0-.65.125-.884.348-.234.223-.366.525-.366.84v2.77H1.25c-.331 0-.65.126-.884.348-.234.223-.366.525-.366.84v12.667c0 .315.132.617.366.84.235.222.553.347.884.347h13.334c.331 0 .649-.125.883-.348.235-.222.367-.524.367-.84V5.147c0-.315-.132-.617-.367-.84-.234-.222-.552-.348-.883-.348H12.5zM5 7.125h5.834V1.583H5v5.542zm3.75-.792H7.083V5.146h-1.25V3.563h1.25V2.375H8.75v1.188H10v1.583H8.75v1.187z"
                          clip-rule="evenodd"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <path fill="#fff" d="M0 0H15.833V19H0z" transform="matrix(-1 0 0 1 15.834 0)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </td>
                <td style="width: 5px" class="top-time-activity-text-padding-right">
                  <span class="top-time-activity-text-number">{{ index + 1 }}</span>
                </td>
                <td style="text-align: left" class="top-time-activity-text">
                  {{ item.siteName }}
                </td>
                <td style="text-align: right" class="top-time-activity-text">
                  <span>{{ item.numParticipant }}</span>
                </td>
              </tr>
            </div>

            <div v-else class="align-center p-60">
              <div class="card-text-title no-data" v-if="dataLoaded">
                No Data In
              </div>
            </div>
          </tbody>
        </table>

        <div class="col-xl-12 color_slate-grey pt-15" v-bind:class="{ presets: tDateShow }">
          {{ todayDate }}
        </div>
      </b-card-body>
    </div>

    <div class="text-right" v-if="!hideFooter && tDateShow && ((tabIndex == 0 && topFiveSites.length !== 0) || (tabIndex == 1 && topFiveCountries.length !== 0))">
      <span class="pr-10">
        <img src="static/img/download-graphs.png" class="download_graph cursor_pointer" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Download" />
        <div class="dropdown-menu download-dropdown-box p-0 dropdown-menu-right">
          <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="downloadGraphs('#top-sites-countries', 'csv')"><img src="/static/img/csv.svg" class="mr-6" />CSV</span>
          <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="downloadGraphs('#top-sites-countries', 'pdf')"><img src="/static/img/pdf.svg" class="mr-6" />PDF</span>
          <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="downloadGraphs('#top-sites-countries', 'png')"><img src="/static/img/img.svg" class="mr-6" />PNG</span>
        </div>
      </span>
    </div>
  </b-card>
</template>
<script>
import jspdf from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import { downloadCSV } from "../../services/visualization/recruitment";

export default {
  props: {
    hideFooter: { type: Boolean, default: false },
    topFiveCountries: Array,
    topFiveSites: Array,
    dataLoaded: { type: Boolean, default: false }
  },
  data() {
    return {
      todayDate: "",
      tDateShow: true,
      title: "Top 5 Locations for Participant Enrollment",
      tabIndex: 0,
      primaryColor: "#000"
    };
  },
  watch: {
    topFiveCountries: function() {
      const primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
      this.primaryColor = primaryColor || "#00C3B3";
    },
    topFiveSites: function() {
      const primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
      this.primaryColor = primaryColor || "#00C3B3";
    }
  },
  mounted() {
    const primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
    this.primaryColor = primaryColor || "#00C3B3";
  },
  methods: {
    showDate() {},
    downloadGraphs(containerId, type) {
      this.todayDate = moment()
        .format("DD MMM YYYY hh:mm:ss")
        .toUpperCase();
      this.tDateShow = false;
      setTimeout(() => {
        switch (type) {
          case "csv":
            this.tDateShow = true;
            if (this.tabIndex == 0) {
              const newArr = [];
              const header = ["Site Name", "Participants"];
              this.topFiveSites.map(row => {
                newArr.push([row.siteName, row.numParticipant]);
              });
              downloadCSV(this.title, header, newArr);
            } else {
              const newArr = [];
              const header = ["Country", "Participants"];
              this.topFiveCountries.map(row => {
                newArr.push([row.countryName, row.numParticipant]);
              });
              downloadCSV(this.title, header, newArr);
            }
            break;
          case "pdf":
            let filename = this.title + "_" + this.todayDate + ".pdf";
            this.tDateShow = true;
            html2canvas(document.querySelector(containerId), {
              allowTaint: true,
              logging: false,
              scrollY: -window.scrollY,
              scrollX: -window.scrollX,
              onclone: document => {
                document.querySelectorAll(containerId + " .nav-item").forEach(element => {
                  const ele = element.querySelector(".nav-link.active");
                  if (!ele) {
                    element.remove();
                  }
                });
              }
            }).then(canvas => {
              const imgData = canvas.toDataURL("image/png");
              const pdf = new jspdf("p", "mm", "a4");
              const imgProps = pdf.getImageProperties(imgData);
              const pdfWidth = pdf.internal.pageSize.getWidth();
              const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
              pdf.addImage(imgData, "PNG", 0, 0, pdfWidth - 5, pdfHeight);
              pdf.save(filename);
            });
            break;
          case "png":
            let that = this;
            this.tDateShow = true;
            html2canvas(document.querySelector(containerId), {
              allowTaint: true,
              logging: false,
              scrollY: -window.scrollY,
              scrollX: -window.scrollX,
              onclone: document => {
                document.querySelectorAll(containerId + " .nav-item").forEach(element => {
                  const ele = element.querySelector(".nav-link.active");
                  if (!ele) {
                    element.remove();
                  }
                });
              }
            }).then(function(canvas) {
              const link = document.createElement("a");
              document.body.appendChild(link);
              link.download = that.title + "_" + that.todayDate + ".png";
              link.href = canvas.toDataURL("image/png");
              link.target = "_blank";
              link.click();
            });
            break;
        }
      }, 1);
    }
  }
};
</script>
<style lang="scss" scoped>
.pdt-5 {
  margin-right: 2.2px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 23px;
}

.full-width-100 {
  width: 100%;
}
</style>
